(function () {
  /* =====================================================================
   * CONFIG
   * ================================================================== */
  var EMPOWER_CODE = 'EMPOWER';
  var LOGIN_PATH = '/account/login';
  var REGISTER_ENDPOINT = 'https://empower-registered.medisa.au/register';
  var RESUME_KEY = 'mdsa_empower_resume_v1';
  var RESUME_TTL_MS = 30 * 60 * 1000;

  // How long we wait for the tag to be written before adding to cart
  // anyway. The tag must exist BEFORE /cart/add, otherwise Shopify
  // renders the drawer without the automatic discount.
  var REGISTER_TIMEOUT_MS = 4000;

  /* =====================================================================
   * STATE
   * ================================================================== */
  var pendingButton = null;
  var pendingForm = null;
  var bypassEmpowerOnce = false;

  /* =====================================================================
   * HELPERS
   * ================================================================== */
  function isLoggedIn() {
    return !!(window.medisaCustomer && window.medisaCustomer.id);
  }

  function isEmpowerRegistered() {
    return !!(
      window.medisaCustomer &&
      Array.isArray(window.medisaCustomer.tags) &&
      window.medisaCustomer.tags.includes('empower_registered')
    );
  }

  function getModal() {
    return document.querySelector('[data-empower-modal]');
  }

  function setModalView(view) {
    var modal = getModal();
    if (!modal) return;
    modal.classList.remove('is-view-member', 'is-view-guest', 'is-view-code');
    modal.classList.add('is-view-' + view);
  }

  function getFormForButton(button) {
    var formId = button.getAttribute('data-form');
    return formId ? document.getElementById(formId) : button.closest('form');
  }

  /* =====================================================================
   * PRODUCT DATA
   * ================================================================== */
  function readProductData() {
    var node = document.querySelector('[data-empower-product-data]');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      console.warn('EMPOWER: could not parse product data', e);
      return null;
    }
  }

  function getSelectedVariantId(form) {
    if (!form) return null;
    var input = form.querySelector('[name="id"]');
    return input ? String(input.value) : null;
  }

  function getQuantity(form) {
    if (!form) return 1;
    var input = form.querySelector('[name="quantity"]');
    var value = input ? parseInt(input.value, 10) : 1;
    return value > 0 ? value : 1;
  }

  /**
   * The item the customer had selected at the moment they accepted the
   * consent modal. This is all we can honestly report: the order does
   * not exist yet, and they may add or remove items afterwards.
   */
  function getSelectedItem(form) {
    var data = readProductData();
    if (!data) return null;

    var variantId = getSelectedVariantId(form);
    var variant = variantId ? data.variants[variantId] : null;

    if (!variant) {
      var keys = Object.keys(data.variants || {});
      if (!keys.length) return null;
      variantId = keys[0];
      variant = data.variants[variantId];
    }

    return {
      productTitle: data.title || '',
      variantTitle: variant.title || '',
      variantId: variantId,
      sku: variant.sku || '',
      price: variant.price || '',
      empowerPrice: variant.empowerPrice || '',
      quantity: getQuantity(form),
      url: data.url ? window.location.origin + data.url : window.location.href,
    };
  }

  /* =====================================================================
   * PHONE FIELD
   *
   * The field is prefilled by Liquid only when the account holds exactly
   * one distinct number. Whatever the customer leaves here is what we
   * send — their confirmation is the only reliable signal that a number
   * is actually theirs.
   * ================================================================== */
  function getPhoneInput() {
    var modal = getModal();
    return modal ? modal.querySelector('[data-empower-phone]') : null;
  }

  function getPhoneValue() {
    var input = getPhoneInput();
    return input ? input.value.trim() : '';
  }

  function isPlausiblePhone(value) {
    if (!value) return true; // optional — blank is fine
    var digits = value.replace(/\D/g, '');
    return digits.length >= 8 && digits.length <= 15;
  }

  function showPhoneError(message) {
    var modal = getModal();
    if (!modal) return;

    var input = modal.querySelector('[data-empower-phone]');
    var help = modal.querySelector('.mdsa-empower-field__help');

    if (input) input.classList.toggle('is-invalid', !!message);

    if (help) {
      help.classList.toggle('is-error', !!message);
      if (message) {
        if (!help.dataset.original) help.dataset.original = help.textContent;
        help.textContent = message;
      } else if (help.dataset.original) {
        help.textContent = help.dataset.original;
      }
    }
  }

  function populateModal(form) {
    var data = readProductData();
    if (!data) return;

    var variantId = getSelectedVariantId(form);
    var variant = variantId ? data.variants[variantId] : null;

    if (!variant) {
      var keys = Object.keys(data.variants || {});
      variant = keys.length ? data.variants[keys[0]] : null;
    }
    if (!variant) return;

    var modal = getModal();
    if (!modal) return;

    var titleEl = modal.querySelector('[data-empower-title]');
    var skuEl = modal.querySelector('[data-empower-sku]');
    var wasEl = modal.querySelector('[data-empower-price-was]');
    var nowEl = modal.querySelector('[data-empower-price-now]');
    var imgEl = modal.querySelector('[data-empower-image]');

    if (titleEl) titleEl.textContent = data.title || '';
    if (skuEl) skuEl.textContent = variant.sku || '—';
    if (wasEl) wasEl.textContent = variant.price || '';
    if (nowEl) nowEl.textContent = variant.empowerPrice || '';

    if (imgEl) {
      if (variant.image) {
        imgEl.src = variant.image;
        imgEl.alt = data.title || '';
        imgEl.style.visibility = '';
      } else {
        imgEl.removeAttribute('src');
        imgEl.style.visibility = 'hidden';
      }
    }
  }

  /* =====================================================================
   * MODAL OPEN / CLOSE
   * ================================================================== */
  function openModal(button, form, view) {
    var modal = getModal();
    if (!modal) return;

    pendingButton = button;
    pendingForm = form;

    populateModal(form);
    setModalView(view || (isLoggedIn() ? 'member' : 'guest'));

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';

    setAgreeLoading(false);

    pendingButton = null;
    pendingForm = null;
  }

  function setAgreeLoading(isLoading, message) {
    var modal = getModal();
    if (!modal) return;

    var button = modal.querySelector('[data-empower-agree]');
    var label = modal.querySelector('[data-empower-agree-label]');
    var skip = modal.querySelector('[data-empower-skip]');

    if (button) button.disabled = isLoading;
    if (skip) skip.disabled = isLoading;
    if (label) label.textContent = isLoading ? message : 'I Agree & Add to Cart';
  }

  /* =====================================================================
   * LINE ITEM PROPERTIES
   * ================================================================== */
  function removeEmpowerInputs(form) {
    if (!form) return;
    form.querySelectorAll('[data-empower-property]').forEach(function (input) {
      input.remove();
    });
  }

  function addEmpowerInput(form, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.setAttribute('data-empower-property', '');
    form.appendChild(input);
  }

  function addEmpowerConsent(form) {
    removeEmpowerInputs(form);
    addEmpowerInput(form, 'properties[_empower_consent]', 'accepted');
    addEmpowerInput(form, 'properties[_empower_terms_version]', '2026-08');
  }

  /* =====================================================================
   * SUBMIT
   * ================================================================== */
  function submitOriginalForm() {
    if (!pendingForm || !pendingButton) return;

    var form = pendingForm;
    var button = pendingButton;

    closeModal();
    bypassEmpowerOnce = true;

    setTimeout(function () {
      if (button.isConnected) {
        button.click();
      } else if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }

      setTimeout(function () {
        bypassEmpowerOnce = false;
      }, 500);
    }, 50);
  }

  /* =====================================================================
   * REGISTRATION
   * ================================================================== */
  function registerEmpowerCustomer(item, phone) {
    if (!isLoggedIn()) {
      console.warn('EMPOWER: no customer id, skipping registration');
      return Promise.resolve(false);
    }

    console.log('sending empower register', window.medisaCustomer.id, item);

    var request = fetch(REGISTER_ENDPOINT, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customerId: window.medisaCustomer.id,
        item: item || null,
        phone: phone || '',
        consentAt: new Date().toISOString(),
      }),
    })
      .then(function (response) {
        console.log('EMPOWER STATUS', response.status);
        return response.json();
      })
      .then(function (data) {
        console.log('EMPOWER RESPONSE', data);
        return !!(data && data.success);
      })
      .catch(function (error) {
        console.error('EMPOWER ERROR', error);
        return false;
      });

    var timeout = new Promise(function (resolve) {
      setTimeout(function () {
        console.warn('EMPOWER: registration slow, adding to cart anyway');
        resolve(false);
      }, REGISTER_TIMEOUT_MS);
    });

    return Promise.race([request, timeout]);
  }

  /* =====================================================================
   * RESUME-AFTER-LOGIN
   * ================================================================== */
  function saveResume() {
    try {
      localStorage.setItem(
        RESUME_KEY,
        JSON.stringify({
          path: window.location.pathname + window.location.search,
          ts: Date.now(),
        })
      );
    } catch (e) {
      /* private mode — non-fatal */
    }
  }

  function readResume() {
    try {
      var raw = localStorage.getItem(RESUME_KEY);
      if (!raw) return null;

      var data = JSON.parse(raw);
      if (!data || !data.path) return null;

      if (Date.now() - data.ts > RESUME_TTL_MS) {
        clearResume();
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function clearResume() {
    try {
      localStorage.removeItem(RESUME_KEY);
    } catch (e) {
      /* noop */
    }
  }

  function handleResume() {
    var resume = readResume();
    if (!resume || !isLoggedIn()) return;

    var here = window.location.pathname + window.location.search;
    var resumePath = resume.path.split('?')[0];

    if (here === resume.path || window.location.pathname === resumePath) {
      clearResume();
      if (isEmpowerRegistered()) return;

      var button = document.querySelector('[data-add-to-cart][data-empower-eligible="true"]');
      if (!button) return;

      var form = getFormForButton(button);
      if (!form) return;

      setTimeout(function () {
        openModal(button, form, 'member');
      }, 600);
      return;
    }

    clearResume();
    window.location.href = resume.path;
  }

  /* =====================================================================
   * INTERCEPT ADD TO CART
   * ================================================================== */
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('[data-add-to-cart]');
      if (!button) return;

      if (bypassEmpowerOnce) {
        bypassEmpowerOnce = false;
        return;
      }

      var eligible = button.getAttribute('data-empower-eligible') === 'true';
      var registered =
        button.getAttribute('data-empower-registered') === 'true' || isEmpowerRegistered();

      if (!eligible || registered) return;

      var form = getFormForButton(button);
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      removeEmpowerInputs(form);
      openModal(button, form, isLoggedIn() ? 'member' : 'guest');
    },
    true
  );

  /* =====================================================================
   * MODAL ACTIONS
   * ================================================================== */
  document.addEventListener('click', function (event) {
    /* ---- Agree (logged in) --------------------------------------- */
    if (event.target.closest('[data-empower-agree]')) {
      event.preventDefault();
      if (!pendingForm) return;

      // Capture the item and phone BEFORE the modal closes and refs clear
      var item = getSelectedItem(pendingForm);
      var phone = getPhoneValue();

      if (!isPlausiblePhone(phone)) {
        showPhoneError('That does not look like a valid phone number.');
        var phoneInput = getPhoneInput();
        if (phoneInput) phoneInput.focus();
        return;
      }

      showPhoneError('');

      addEmpowerConsent(pendingForm);
      console.log('EMPOWER ACCEPT CLICK', item);

      setAgreeLoading(true, 'Applying your discount\u2026');

      // Wait for the tag to be written BEFORE adding to cart, so the
      // cart drawer opens with the discount already applied.
      registerEmpowerCustomer(item, phone).then(function () {
        if (window.medisaCustomer && Array.isArray(window.medisaCustomer.tags)) {
          if (!window.medisaCustomer.tags.includes('empower_registered')) {
            window.medisaCustomer.tags.push('empower_registered');
          }
        }

        document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
          btn.setAttribute('data-empower-registered', 'true');
        });

        submitOriginalForm();
      });

      return;
    }

    /* ---- Skip ---------------------------------------------------- */
    if (event.target.closest('[data-empower-skip]')) {
      event.preventDefault();
      if (!pendingForm) return;

      removeEmpowerInputs(pendingForm);
      submitOriginalForm();
      return;
    }

    /* ---- Guest: sign in ------------------------------------------ */
    if (event.target.closest('[data-empower-login]')) {
      event.preventDefault();
      saveResume();

      window.location.href =
        LOGIN_PATH +
        '?return_url=' +
        encodeURIComponent(window.location.pathname + window.location.search);
      return;
    }

    /* ---- Guest: continue without signing in ---------------------- */
    if (event.target.closest('[data-empower-guest-continue]')) {
      event.preventDefault();
      setModalView('code');
      return;
    }

    /* ---- Guest: apply code --------------------------------------- */
    var applyButton = event.target.closest('[data-empower-apply-code]');
    if (applyButton) {
      event.preventDefault();
      if (!pendingForm) return;

      applyButton.disabled = true;

      fetch('/discount/' + encodeURIComponent(EMPOWER_CODE), {
        method: 'GET',
        credentials: 'same-origin',
      })
        .catch(function (error) {
          console.warn('EMPOWER CODE ERROR', error);
        })
        .then(function () {
          applyButton.disabled = false;
          submitOriginalForm();
        });
      return;
    }

    /* ---- Close / Go Back ----------------------------------------- */
    if (event.target.closest('[data-empower-close]')) {
      event.preventDefault();
      if (pendingForm) removeEmpowerInputs(pendingForm);
      closeModal();
    }
  });

  /* =====================================================================
   * ESCAPE KEY
   * ================================================================== */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var modal = getModal();
    if (!modal || !modal.classList.contains('is-open')) return;

    if (pendingForm) removeEmpowerInputs(pendingForm);
    closeModal();
  });

  /* =====================================================================
   * BOOT
   * ================================================================== */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleResume);
  } else {
    handleResume();
  }
})();